import React, { useCallback } from 'react';
import Linkify from 'react-linkify';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';

const LinkifyText = ({ children }) => {
  const { t } = useTranslation('global', { keyPrefix: 'ChatMessageStream.message' });

  const confirmLeave = useCallback(
    e => {
      e.stopPropagation();
      /* eslint-disable-next-line */
      if (!confirm(t('link_confirmation_message'))) {
        e.preventDefault();
      }
    },
    [t],
  );

  return (
    <Linkify
      className="overflow-hidden"
      properties={{
        onClick: confirmLeave,
        className: 'text-blue-500 hover:underline break-all',
        target: '_blank',
      }}
    >
      {children}
    </Linkify>
  );
};

LinkifyText.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LinkifyText;
